import React from "react"
import PropTypes from "prop-types"
import { InputNumber, theme } from "antd"

const InputDistributionAmount = ({
  valueInCents = 0,
  disabled = false,
  isCustom = false,
  onChange,
}) => {
  const { token } = theme.useToken()

  const style = {
    width: "100%",
    ...(isCustom && { backgroundColor: token.colorWarningBg }),
  }

  const currentValue = (Number(valueInCents) || 0) / 100

  const formatter = value =>
    `${Number(value || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`

  const parser = value =>
    Number(`${value}`.replace(/[^0-9.-]/g, ""))

  const handleChange = value =>
    onChange(Math.round((Number(value) || 0) * 100))

  const inputNumberProps = {
    min: 0,
    value: currentValue,
    prefix: "$",
    precision: 2,
    style,
    parser,
    disabled,
    formatter,
    onChange: handleChange,
  }

  return <InputNumber {...inputNumberProps} />
}

InputDistributionAmount.propTypes = {
  valueInCents: PropTypes.number,
  disabled: PropTypes.bool,
  isCustom: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
}

export default InputDistributionAmount
